import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  types: [],
  totalTypesPages: 0,
  totalTypesItems: 0,
  tasks: [],
  totalTasksPages: 0,
  totalTasksItems: 0,
  tier: [],
  totalTiersPages: 0,
  totalTiersItems: 0,
  sponsors: [],
  sponsorTags: null,
  totalSponsorsPages: 0,
  totalSponsorsItems: 0,
  mediaKits: []
}

const getters = {
  sponsorsTypeList: state => state.types,
  totalTypesItems: state => state.totalTypesItems,
  totalTypesPages: state => state.totalTypesPages,
  sponsorsTaskList: state => state.tasks,
  totalTasksItems: state => state.totalTasksItems,
  totalTasksPages: state => state.totalTasksPages,
  sponsorsTiersList: state => state.tier,
  totalTiersItems: state => state.totalTiersItems,
  totalTiersPages: state => state.totalTiersPages,
  sponsorsList: state => state.sponsors,
  totalSponsorsPages: state => state.totalSponsorsPages,
  totalSponsorsItems: state => state.totalSponsorsItems,
  sponsorsTagsList: state => state.sponsorTags,
  getSponsorsTypeById: state => id => state.types.find(type => type.id === id),
  getSponsorById: state => id => state.sponsors.find(sponsor => sponsor.id === id),
  getMediaKits: state => state.mediaKits
}

const actions = {
  async createSponsorType ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.sponsors.createSponsorType(), { ...type })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Type was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Type wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSponsorsList ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.sponsors.getSponsors(payload))
      commit(types.SET_SPONSORS_LIST, data)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Error in loading sponsors list!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editSponsorType ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.editSponsorType(), { ...type })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Type was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Type wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSponsorTypesList ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.sponsors.getSponsorTypes(payload))
      commit(types.SET_SPONSOR_TYPES_LIST, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor\'s types wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeSponsorType ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.sponsors.deleteSponsorType(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Type was removed successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Type wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createSponsorTask ({ commit }, task) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.sponsors.createSponsorTask(), { ...task })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Task was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Task wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createSponsorTier ({ commit }, tier) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.sponsors.createSponsorTier(), { ...tier })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Tier was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Tier wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editSponsorTask ({ commit }, task) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.editSponsorTask(), { ...task })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Task was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Task wasn\'t updated')
      throw err
    }
  },
  async fetchSponsorTiersList ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.sponsors.getSponsorTiers(payload))
      commit(types.SET_SPONSOR_TIERS_LIST, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor\'s tiers wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeSponsorTier ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.sponsors.deleteSponsorTier(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Tier was removed successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Tier wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeSponsorTask ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.sponsors.deleteSponsorTask(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Task was removed successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Task wasn\'t removed')
      throw err
    }
  },
  async sendReminderWithSponsorTasks ({ commit }, tasks) {
    try {
      await this.$axios.post(api.sponsors.sendReminderWithSponsorTasks(), { ...tasks })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor received reminder message')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor did\'t receive reminder message')
      throw err
    }
  },
  async recieveEmailTemplates ({ commit }) {
    try {
      return await this.$axios.get(api.sponsors.recieveEmailTemplates())
    } catch (err) {
      console.log(err)
      throw err
    }
  },
  async editSponsorTier ({ commit }, tier) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.editSponsorTier(), { ...tier })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Tier was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Tier wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSponsorTasksList ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.sponsors.getSponsorTasks(payload))
      commit(types.SET_SPONSOR_TASKS_LIST, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor\'s tasks wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSponsorsTagsList ({ commit }) {
    try {
      const { data: { tags } } = await this.$axios
        .get(api.tag.getTag())
      commit(types.SET_SPONSORS_TAGS_LIST, tags)
    } catch (err) {
      throw err
    }
  },
  async editSponsor ({ commit }, sponsor) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.editSponsor(), { ...sponsor })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteSponsor ({ commit }, ids) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.sponsors.deleteSponsor(ids))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createNewSponsor ({ commit }, newSponsorData) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.sponsors.createSponsor(), { ...newSponsorData })
      commit(types.CREATE_SUCCESS_MESSAGE, 'New sponsor was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateSponsorPublish ({ commit }, sponsorsIds) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.updateSponsorPublish(), { sponsorsIds })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor was changed status')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t changed status')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editSponsorsSettings ({ commit, getters }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      // const settings = path(['getSettings', 'sponsorsSetting', 'displaySettingsObject'], getters)
      // const settings = getters.getSponsorsSettings
      // settings.displaySettings = clone(payload)
      // commit(types.SET_SPONSORS_SETTINGS, settings)
      // console.log(payload)
      await this.$axios.put(api.sponsors.setSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings saved!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsors settings wasn\'t saved')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateSponsorDraft ({ commit }, ids) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.updateSponsorDraft(), { ids })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor was changed status')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t changed status')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchMediaKits ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data: { mediaKits } } = await this.$axios.get(api.sponsors.getMediaKits())
      commit(types.SET_MEDIA_KITS, mediaKits)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Media kits waren\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createMediaKit ({ commit }, mediaKit) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.sponsors.createMediaKit(), mediaKit)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Media kit was created')
      await this.dispatch('fetchMediaKits')
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0055') {
        commit(types.CREATE_ERROR_MESSAGE, 'Media kit with such name has already existed')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Media kit wasn\'t created')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateMediaKit ({ commit }, mediaKit) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.updateMediaKit(), mediaKit)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Media kit was updated')
      await this.dispatch('fetchMediaKits')
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0055') {
        commit(types.CREATE_ERROR_MESSAGE, 'Media kit with such name has already existed')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Media kit wasn\'t updated')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteMediaKit ({ commit }, mediaKitId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.sponsors.deleteMediaKit(mediaKitId))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Media kit was deleted')
      await this.dispatch('fetchMediaKits')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Media kit wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateSponsorTask ({ commit }, { tasks, id }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.updateSponsorTask(), { tasks, id })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sponsor was changed tasks')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sponsor wasn\'t changed tasks')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateMediaKitsSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.sponsors.updateMediaKitsSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Media kits settings were successfully updated')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to update media kit settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_SPONSOR_TYPES_LIST] (state, { sponsorTypes, totalPages, totalItems }) {
    state.types = [...sponsorTypes]
    state.totalTypesPages = totalPages
    state.totalTypesItems = totalItems
  },
  [types.SET_SPONSOR_TASKS_LIST] (state, { sponsorTasks, totalPages, totalItems }) {
    state.tasks = [...sponsorTasks]
    state.totalTasksPages = totalPages
    state.totalTasksItems = totalItems
  },
  [types.SET_SPONSOR_TIERS_LIST] (state, { attendeeTypes, totalPages, totalItems }) {
    state.tier = [...attendeeTypes]
    state.totalTiersPages = totalPages
    state.totalTiersItems = totalItems
  },
  [types.SET_SPONSORS_LIST] (state, { sponsors, totalPages, totalItems }) {
    state.sponsors = [...sponsors]
    state.totalSponsorsPages = totalPages
    state.totalSponsorsItems = totalItems
  },
  [types.SET_SPONSORS_TAGS_LIST] (state, sponsorTags) {
    state.sponsorTags = [...sponsorTags]
  },
  [types.SET_MEDIA_KITS] (state, mediaKits) {
    state.mediaKits = [...mediaKits]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sponsors.js